/* eslint-disable no-unused-vars */
export default {
    init () {

        if (window.addEventListener) {
            // For standards-compliant web browsers
            window.addEventListener("message", this.processCordovaWrapperMessage, false);
        }
        else {
            window.attachEvent("onmessage", this.processCordovaWrapperMessage);
        }

    },
    processCordovaWrapperMessage(evt)
    {
        var message = evt.data;
	
        if (!message.indexOf) return;		

        console.log("*** Mensaje recibido: " + message);

        if (message.indexOf("PLATFORM:") == 0) {
						window.$store.commit('wedrive/setDevicePlatform', message.substring(9));
        }

        if (message.indexOf("SEND_EMAIL_ERROR") == 0) {
            window.$vue.$emit('send-email-error');
        }

        if (message.indexOf("PRINTER_LIST:") == 0) {
            window.$vue.$emit('printer-list', JSON.parse(message.substring(13)));
        }

        if (message.indexOf("CONNECT_RESULT:") == 0) {
            window.$vue.$emit('printer-connection-result', JSON.parse(message.substring(15)));
        }

        if (message.indexOf("PRINT_RESULT:") == 0) {
            window.$vue.$emit('print-result', JSON.parse(message.substring(13)));
        }

        if (message.indexOf("NE_BACKBUTTON") == 0) {
            window.$vue.$emit('ne_backbutton');
        }
    },
    sendCordovaWrapperMessage(message)
    {
        parent.postMessage(message, "*");
    },
    initCompleted () {
        this.sendCordovaWrapperMessage('INIT_COMPLETED');
    },
    sendEmailOld(data) {
			this.sendCordovaWrapperMessage('SEND_EMAIL:' + JSON.stringify(data));
		},
    sendEmail(data) {
				// split data in chunks of 100k	
				const size = 100000;	
				const str = JSON.stringify(data);		
				const numChunks = Math.ceil(str.length / size);
				if (numChunks == 1) {
						this.sendCordovaWrapperMessage('SEND_EMAIL:INIT:' + str.substr(0 * size, size));
						this.sendCordovaWrapperMessage('SEND_EMAIL:LAST:');
				} else if (numChunks == 2) {
						this.sendCordovaWrapperMessage('SEND_EMAIL:INIT:' + str.substr(0 * size, size));
						this.sendCordovaWrapperMessage('SEND_EMAIL:LAST:' + str.substr(1 * size, size));
				} else {
						for (var i = 0; i < numChunks; i++) {
								if (i == 0) {
										this.doSendEmailChunk('SEND_EMAIL:INIT:' + str.substr(i * size, size));
								} else if (i == numChunks - 1) {
										this.doSendEmailChunk('SEND_EMAIL:LAST:' + str.substr(i * size, size));
								} else {
										this.doSendEmailChunk('SEND_EMAIL:PART:' + str.substr(i * size, size));
								}
						}					
				}
        //this.sendCordovaWrapperMessage('SEND_EMAIL:' + JSON.stringify(data));
    },
		doSendEmailChunk(chunk) {
			setTimeout(() => {
					this.sendCordovaWrapperMessage(chunk);
			}, 100);
		},
    getPrinterList() {
        this.sendCordovaWrapperMessage('GET_PRINTERS');
    },
    connectPrinter(name) {
        this.sendCordovaWrapperMessage('CONNECT_PRINTER:' + JSON.stringify(name));
    },
    printTicket(lines) {
        this.sendCordovaWrapperMessage('PRINT_LINES:' + JSON.stringify(lines));
    },
		openUrl(url) {
				this.sendCordovaWrapperMessage('OPEN_URL:' + url);
		},
}